import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { setRef } from '../../hooks/useForkRef.js';
import { useIsomorphicLayoutEffect } from '../../hooks/useIsoMorphicLayoutEffect.js';

var Portal = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var container = props.container,
      children = props.children;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      mountNode = _React$useState2[0],
      setMountNode = _React$useState2[1];

  useIsomorphicLayoutEffect(function () {
    var containerEl = typeof container === 'function' ? container() : container;
    setMountNode(containerEl || document.body);
  }, [container]);
  useIsomorphicLayoutEffect(function () {
    if (mountNode) {
      setRef(ref, mountNode);
    }
  }, [ref, mountNode]);
  return mountNode ? /*#__PURE__*/ReactDOM.createPortal(children, mountNode) : mountNode;
});

export { Portal };
